<template>
  <div class="page-wrap" style="max-width: 750px;" v-show="show">
    <div class="header-wrap">
      <div class="card-wrap">
        <div
          class="card"
          v-for="(item, index) in RoadsRecommendList"
          :key="item._id"
        >
          <router-link :to="'/detail?type=Roads&id=' + item._id">
            <img :src="RoadsImagesList[index].tempFileURL" alt="" />
            <div class="card-info">
              <div class="card-title">{{ item.Name }}</div>
              <div class="card-tags-wrap" v-html="getAges(item)"></div>
            </div>
          </router-link>
        </div>
        <div
          class="card"
          v-for="(item, index) in CourseRecommendList"
          :key="item._id"
        >
          <router-link :to="'/detail?type=Course&id=' + item._id">
            <img :src="CourseImagesList[index].tempFileURL" alt="" />
            <div class="card-info">
              <div class="card-title">{{ item.Name }}</div>
              <div class="card-tags-wrap" v-html="getAges(item)"></div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- 历史类 -->
    <div></div>
    <section v-show="HistoryClassList.length">
      <div class="section-header">
        <div class="section-header-title">历史类</div>
        <div class="more">
          <router-link to="/list?type=1">查看更多</router-link>
        </div>
      </div>
      <div class="section-content">
        <div
          class="section-img-wrap"
          v-for="item in HistoryClassList"
          :key="item._id"
        >
          <router-link
            :to="'/detail?type=' + item.slefType + '&id=' + item._id"
          >
            <div class="img-wrap">
              <img :src="item.tempFileURL" alt="" />
            </div>
            <div class="section-info">
              <div class="section-title">{{ item.Name }}</div>
              <div class="section-desc">{{ item.Owner }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
    <!-- 红色类 -->
    <section v-show="RedClassList.length">
      <div class="section-header">
        <div class="section-header-title">红色类</div>
        <div class="more">
          <router-link to="/list?type=2">查看更多</router-link>
        </div>
      </div>
      <div class="section-content">
        <div
          class="section-img-wrap"
          v-for="item in RedClassList"
          :key="item._id"
        >
          <router-link
            :to="'/detail?type=' + item.slefType + '&id=' + item._id"
          >
            <div class="img-wrap">
              <img :src="item.tempFileURL" alt="" />
            </div>
            <div class="section-info">
              <div class="section-title">{{ item.Name }}</div>
              <div class="section-desc">{{ item.Owner }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
    <!-- 自然类 -->
    <section v-show="NatureClassList.length">
      <div class="section-header">
        <div class="section-header-title">自然类</div>
        <div class="more">
          <router-link to="/list?type=3">查看更多</router-link>
        </div>
      </div>
      <div class="section-content">
        <div
          class="section-img-wrap"
          v-for="item in NatureClassList"
          :key="item._id"
        >
          <router-link
            :to="'/detail?type=' + item.slefType + '&id=' + item._id"
          >
            <div class="img-wrap">
              <img :src="item.tempFileURL" alt="" />
            </div>
            <div class="section-info">
              <div class="section-title">{{ item.Name }}</div>
              <div class="section-desc">{{ item.Owner }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
    <!-- 科技类 -->
    <section v-show="ScienceClassList.length">
      <div class="section-header">
        <div class="section-header-title">科技类</div>
        <div class="more">
          <router-link to="/list?type=4">查看更多</router-link>
        </div>
      </div>
      <div class="section-content">
        <div
          class="section-img-wrap"
          v-for="item in ScienceClassList"
          :key="item._id"
        >
          <router-link
            :to="'/detail?type=' + item.slefType + '&id=' + item._id"
          >
            <div class="img-wrap">
              <img :src="item.tempFileURL" alt="" />
            </div>
            <div class="section-info">
              <div class="section-title">{{ item.Name }}</div>
              <div class="section-desc">{{ item.Owner }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
    <!-- 民族民俗类 -->
    <section v-show="NationClassList.length">
      <div class="section-header">
        <div class="section-header-title">民族民俗类</div>
        <div class="more">
          <router-link to="/list?type=5">查看更多</router-link>
        </div>
      </div>
      <div class="section-content">
        <div
          class="section-img-wrap"
          v-for="item in NationClassList"
          :key="item._id"
        >
          <router-link
            :to="'/detail?type=' + item.slefType + '&id=' + item._id"
          >
            <div class="img-wrap">
              <img :src="item.tempFileURL" alt="" />
            </div>
            <div class="section-info">
              <div class="section-title">{{ item.Name }}</div>
              <div class="section-desc">{{ item.Owner }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
    <!-- 艺术类 -->
    <section v-show="ArtClassList.length">
      <div class="section-header">
        <div class="section-header-title">艺术类</div>
        <div class="more">
          <router-link to="/list?type=6">查看更多</router-link>
        </div>
      </div>
      <div class="section-content">
        <div
          class="section-img-wrap"
          v-for="item in ArtClassList"
          :key="item._id"
        >
          <router-link
            :to="'/detail?type=' + item.slefType + '&id=' + item._id"
          >
            <div class="img-wrap">
              <img :src="item.tempFileURL" alt="" />
            </div>
            <div class="section-info">
              <div class="section-title">{{ item.Name }}</div>
              <div class="section-desc">{{ item.Owner }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
    <footer-component></footer-component>
  </div>
</template>

<script>
import FooterComponent from "../components/FooterComponent";
import { getImgToCloud, getIndexInfoList } from "../util/util";
export default {
  components: {
    FooterComponent,
  },
  data() {
    return {
      show: false,
      RoadsRecommendList: [],
      CourseRecommendList: [],
      RoadsImagesList: [],
      CourseImagesList: [],
      HistoryClassList: [], // 历史类
      RedClassList: [], //红色类
      ArtClassList: [], //艺术类
      NatureClassList: [], //自然类
      NationClassList: [], //民族民俗类
      ScienceClassList: [], //科技类
    };
  },
  beforeCreate() {
    // 登录成功
  },
  created() {
    this.getRoadsRecommend();
    this.getCourseRecommend();
    this.getListInfo();
  },
  methods: {
    getAges(item) {
      let str = `<span class="tag">${
        item.slefType == "Roads" ? "线路" : "课程"
      }</span><span class="tag">${item.Class}</span>`;
      item.Age.split(",").map((age) => {
        str += `<span class="tag">${age}</span>`;
      });
      return str;
    },
    // 获取所有路线
    getAllRoads(params = {}) {
      const db = this.$TCB_App.database();
      const AllRoads = db.collection("DataBase_All_Roads");
      return AllRoads.orderBy("EditDate", "desc").where(params).get();
    },
    // 获取推荐路线
    getRoadsRecommend() {
      const db = this.$TCB_App.database();
      const RoadsRecommend = db.collection("DataBase_Roads_Recommend");
      const _ = db.command;
      RoadsRecommend.get()
        .then((res) => {
          const list = res.data.map((item) => {
            return item.Road_ID;
          });
          this.getAllRoads({
            _id: _.in(list),
          })
            .then((res) => {
              const ids = res.data.map((item) => {
                item.slefType = 'Roads'
                return item._id;
              });
              if (ids.length > 0) {
                getImgToCloud({
                  name: "Roads",
                  ids: ids,
                }).then((data) => {
                  this.RoadsImagesList = this.RoadsImagesList.concat(
                    data.fileList
                  );
                  this.RoadsRecommendList = this.RoadsRecommendList.concat(
                    res.data
                  );
                  this.show = true;
                });
              } else {
                this.RoadsRecommendList = this.RoadsRecommendList.concat(
                  res.data
                );
              }
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 获取所有课程
    getAllCourse(params = {}) {
      const db = this.$TCB_App.database();
      const AllCourse = db.collection("DataBase_All_Course");
      return AllCourse.orderBy("EditDate", "desc").where(params).get();
    },
    // 获取推荐课程
    getCourseRecommend() {
      const db = this.$TCB_App.database();
      const CourseRecommend = db.collection("DataBase_Course_Recommend");
      const _ = db.command;
      CourseRecommend.get()
        .then((res) => {
          const list = res.data.map((item) => {
            return item.Course_ID;
          });
          this.getAllCourse({
            _id: _.in(list),
          })
            .then((res) => {
              // console.log(res.data);
              const ids = res.data.map((item) => {
                item.slefType = 'Course'
                return item._id;
              });
              if (ids.length > 0) {
                getImgToCloud({
                  name: "Course",
                  ids: ids,
                }).then((data) => {
                  this.CourseImagesList = this.CourseImagesList.concat(
                    data.fileList
                  );
                  this.CourseRecommendList = this.CourseRecommendList.concat(
                    res.data
                  );
                });
              } else {
                this.CourseRecommendList = this.CourseRecommendList.concat(
                  res.data
                );
              }
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getListInfo() {
      getIndexInfoList({
        $TCB_App: this.$TCB_App,
        where: {
          Class: "历史类",
        },
        limit: 4,
      }).then((res) => {
        // console.log(res);
        this.HistoryClassList = this.HistoryClassList.concat(
          res.flat(Infinity)
        );
      });
      getIndexInfoList({
        $TCB_App: this.$TCB_App,
        where: {
          Class: "红色类",
        },
        limit: 4,
      }).then((res) => {
        // console.log(res);
        this.RedClassList = this.RedClassList.concat(res.flat(Infinity));
      });
      getIndexInfoList({
        $TCB_App: this.$TCB_App,
        where: {
          Class: "艺术类",
        },
        limit: 4,
      }).then((res) => {
        // console.log(res);
        this.ArtClassList = this.ArtClassList.concat(res.flat(Infinity));
      });
      getIndexInfoList({
        $TCB_App: this.$TCB_App,
        where: {
          Class: "自然类",
        },
        limit: 4,
      }).then((res) => {
        // console.log(res);
        this.NatureClassList = this.NatureClassList.concat(res.flat(Infinity));
      });
      getIndexInfoList({
        $TCB_App: this.$TCB_App,
        where: {
          Class: "民族民俗类",
        },
        limit: 4,
      }).then((res) => {
        // console.log(res);
        this.NationClassList = this.NationClassList.concat(res.flat(Infinity));
      });
      getIndexInfoList({
        $TCB_App: this.$TCB_App,
        where: {
          Class: "科技类",
        },
        limit: 4,
      }).then((res) => {
        console.log("科技类", res);
        this.ScienceClassList = this.ScienceClassList.concat(
          res.flat(Infinity)
        );
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page-wrap {
  background: #faf9f9;
}
.header-wrap {
  width: 100%;
  height: 67vh;
  overflow-x: scroll;
}
.card-wrap {
  height: 100%;
  position: relative;
  font-size: 0;
  display: inline-flex;
  .card {
    height: 100%;
    width: 80vw;
    margin-right: 2.7vw;
    background: #ccc;
    position: relative;
  }
  img {
    width: 100%;
    height: auto;
  }
  .card-info {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;
    color: #ffffff;
    padding: 4vw;
    .card-title {
      text-align: left;
      font-size: 4.533vw;
      margin-bottom: 2.667vw;
    }
  }
}
section {
  margin-top: 4.667vw;
  background: #ffffff;
  box-shadow: 0 1px 3px 0 #eeeeee;
  .section-header {
    padding: 4vw;
    border-bottom: solid 1px #eee;
    display: flex;
    justify-content: space-between;
    .section-header-title {
      font-size: 5.067vw;
      font-weight: bold;
      color: #111111;
      line-height: 1;
      position: relative;
      padding-left: 3.467vw;
      &::before {
        content: "";
        position: absolute;
        display: inline-block;
        height: 100%;
        width: 0.8vw;
        background: #92bc10;
        left: 0;
        top: 0;
      }
    }
    .more {
      font-size: 4vw;
    }
    .more a {
      color: #71a209;
      text-decoration: none;
    }
  }
  .section-content {
    width: 100%;
    box-sizing: border-box;
    padding: 4vw;
    padding-bottom: 5.333vw;
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .section-img-wrap {
    width: 44vw;
    // height: 44vw;
    border-radius: 6px;
    overflow: hidden;
    position: relative;
    font-size: 0;
    .img-wrap {
      width: 100%;
      height: 33.067vw;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f5f5f5;
      img {
        display: inline-block;
        max-width: 100%;
        max-height: 100%;
      }
    }
    a {
      color: #111;
      text-decoration: none;
    }
  }
  .section-img-wrap:nth-child(n + 3) {
    margin-top: 4vw;
  }

  .section-info {
    width: 100%;
    box-sizing: border-box;
    /* position: absolute;
    bottom: 0;
    left: 0; */
    padding-top: 2.667vw;
    .section-title {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 4.533vw;
      // color: #ffffff;
    }
    .section-desc {
      font-size: 3.2vw;
      color: #7288a6;
      margin-top: 1.333vw;
    }
  }
}
</style>
<style lang="scss">
.card-tags-wrap {
  color: #ffffff;
  span {
    font-size: 3.2vw;
    padding: 0.8vw 1.333vw;
    display: inline-block;
    border-radius: 0.533vw;
    margin-right: 2vw;
    margin-bottom: 1vw;
  }
  span:nth-child(1) {
    background: #7cb6f3;
  }
  span:nth-child(2) {
    background: #e8b585;
  }
  span:nth-child(3) {
    background: #95a7ff;
  }
  span:nth-child(4) {
    background: #85e8a0;
  }
  span:nth-child(5) {
    background: #7cb6f3;
  }
  span:nth-child(6) {
    background: #e8b585;
  }
  span:nth-child(7) {
    background: #95a7ff;
  }
  span:last-child {
    margin-right: 0;
  }
}
</style>